import { defineStore } from 'pinia'

export const useErrorStore = defineStore('error', {
  state: () => ({
    httpError: null,
    errorMessage: null,
    errorBag: null,
    successMessage: null
  }),
  actions: {
    setErrorMessage(message) {
      this.errorMessage = message
    },
    setErrors(errors) {
      this.errors = errors
    },
    clearErrors() {
      this.errorMessage = null
      this.errors = null
    },
    setHttpError(data) {
      this.httpError = data
    },
    clearHttpError() {
      this.httpError = null
    },
    setSuccessMessage(message) {
      this.successMessage = message
    },
    clearSuccessMessage() {
      this.successMessage = null
    }
  }
})
